<template>
  <div 
    :class="baseTextFieldClasses" 
    class="base-text-field"
  >
    <base-icon
      v-if="type === 'search'"
      class="base-text-field__search-icon"
      icon="search"
    />

    <input
      :type="type"
      :placeholder="placeholder"
      :value="value"
      :disabled="isDisabled || isLocked"
      @focus="$emit('focus', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @change="
        emitChange({ val: $event.target.value, files: $event.target.files })
      "
      @click="$emit('click')"
    >

    <base-icon 
      v-if="isLocked" 
      class="base-text-field__lock-icon" 
      icon="lock"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { computed } from "vue";

const props = defineProps({
  value: {
    type: [String, Number, Date],
    default: "",
  },
  variation: {
    type: String,
    default: "",
    validator(value) {
      return ["", "primary", "fill-height"].includes(value);
    },
  },
  type: {
    type: String,
    default: "text",
    validator: function (value) {
      return [
        "text",
        "number",
        "email",
        "password",
        "search",
        "date",
        "color",
        "url",
        "file",
      ].includes(value);
    },
  },
  cap: {
    type: [String, Array],
    default: "",
    validator: function (value) {
      const validTypes = [
        "",
        "top",
        "right",
        "bottom",
        "left",
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left",
      ];

      if (Array.isArray(value)) {
        return value.every((type) => validTypes.includes(type));
      } else {
        return validTypes.includes(value);
      }
    },
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isLocked: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["focus", "blur", "input", "change", "click", "upload"]);

const baseTextFieldClasses = computed(() => ({
  [`base-text-field--type-${props.type}`]: true,
  [`base-text-field--variation-${props.variation}`]: true,
  ...(Array.isArray(props.cap)
    ? props.cap.reduce(
        (acc, c) => ({ ...acc, [`base-text-field--cap-${c}`]: true }),
        {}
      )
    : { [`base-text-field--cap-${props.cap}`]: true }),
  "base-text-field--is-full-width": props.isFullWidth,
  "base-text-field--is-locked": props.isLocked,
}));

const emitChange = ({ val = undefined, files = undefined } = {}) => {
  if (files) {
    emit("upload", files);
  } else {
    emit("change", val);
  }
};
</script>

<style lang="scss" scoped>
@import "./base-text-field.scss";
</style>
